export const BellIcon = ({ size = 12, className = '' }: { size?: number; className?: string }) => (
  <svg width={size} height={size * 13/12} viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <g clipPath="url(#clip0_756_2756)">
      <path d="M11.5297 9.05459C11.4439 8.01624 10.968 7.07633 10.2289 6.33488V4.66622C10.2289 2.68002 8.33655 1.06851 6.00187 1.06851C3.66719 1.06851 1.77294 2.67843 1.77294 4.66622V6.33488C1.03391 7.07633 0.556146 8.01624 0.472165 9.05459L0.324731 10.8519C0.304202 11.1011 0.535618 11.3123 0.828619 11.3123H11.1733C11.4663 11.3123 11.6977 11.1011 11.6771 10.8519L11.5297 9.05459Z" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M4.44168 11.3107L4.51446 11.6648C4.64137 12.2792 5.26843 12.7269 6 12.7269C6.73344 12.7269 7.35863 12.2792 7.48554 11.6648L7.55832 11.3107" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 0.274658V1.0685" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_756_2756">
        <rect width="12" height="13" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
